/**
 * ModuleItemCostTable enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleItemCostTable.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleItemCostTable {
  Ammo = 14,
  Base1 = 0,
  Bonus = 1,
  Damage = 4,
  DamageResist = 7,
  DamageSoak = 6,
  Damage_vulnerability = 22,
  DancingScimitar = 8,
  Immune = 5,
  Light = 18,
  Melee = 2,
  Monster_Cost = 19,
  Negative_Modifiers = 21,
  OnHitCosts = 24,
  OnHitDC_saves = 25,
  Slots = 9,
  SpellLevel = 13,
  SpellResist = 11,
  SpellUse = 3,
  Spell_Level_Immunity = 23,
  Spells = 16,
  Stamina = 12,
  Traps = 17,
  Weight = 10,
  WeightReduction = 15,
}